import React from "react";
import PropTypes from "prop-types";
import translate from "react-i18next/dist/commonjs/translate";

const WidgetErrorMessage = ({ onClick, t }) => {
  return (
    <div className="error-container">
      <h2 className="text-center">Failed to load content</h2>
      <p className="text-center">{t("widgetErrorMessage")}</p>
      <button onClick={onClick} className="btn btn-condensed">
        Try again
      </button>
    </div>
  );
};

WidgetErrorMessage.propTypes = {
  onClick: PropTypes.func.isRequired
};

export default translate("translations")(WidgetErrorMessage);



// WEBPACK FOOTER //
// ./src/dashboard/widgets/WidgetErrorMessage.js